import { Chip, Box } from '@mui/material'
import type { FieldMeta } from '@crm/shared'

interface ReverseLookupFieldProps {
  field: FieldMeta
  value: unknown
  mode: 'view' | 'edit'
  onChange?: (value: unknown) => void
  error?: string
  disabled?: boolean
  hideLabel?: boolean
}

export function ReverseLookupField({ field, value }: ReverseLookupFieldProps) {
  const count = typeof value === 'number' ? value : Array.isArray(value) ? value.length : 0

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      <Chip label={`${count} related`} size="small" variant="outlined" />
    </Box>
  )
}
